"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDealsV2 = exports.getDeals = exports.getReturnCalculatorV2 = exports.getReturnCalculator = exports.getDeal = void 0;
const getDeal = (serverURL, appAxios) => async dealId => await appAxios.get(`${serverURL}/deals/${dealId}`, {
  withCredentials: true
});
exports.getDeal = getDeal;
const getReturnCalculator = (serverURL, appAxios) => async body => await appAxios.post(`${serverURL}/deals/calculator/returns`, body, {
  withCredentials: true
});
exports.getReturnCalculator = getReturnCalculator;
const getReturnCalculatorV2 = (serverURL, appAxios) => async body => await appAxios.post(`${serverURL}/deals/calculator/returns-v2`, body, {
  withCredentials: true
});
exports.getReturnCalculatorV2 = getReturnCalculatorV2;
const getDeals = (serverURL, appAxios) => async params => await appAxios.get(`${serverURL}/deals`, {
  ...(params ? {
    params: {
      ...(params.statuses ? {
        status: params.statuses
      } : {}),
      ...(params.pageSize ? {
        pageSize: params.pageSize
      } : {}),
      ...(params.sortBy ? {
        sortBy: params.sortBy
      } : {})
    }
  } : {}),
  withCredentials: true
});
exports.getDeals = getDeals;
const getDealsV2 = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/deals-v2`, {
  withCredentials: true
});
exports.getDealsV2 = getDealsV2;